export function initSettings() {
    try {
        var hash = window.location.hash || '';
        if (hash.includes('connected=1') || hash.includes('integrations')) {
            if (window.history && window.history.replaceState) {
                window.history.replaceState(null, document.title, window.location.pathname);
            }
            if (hash.includes('connected=1')) {
                var toast = document.getElementById('yandex-connected-toast');
                if (toast) { toast.classList.remove('hidden'); setTimeout(function () { toast.classList.add('hidden'); }, 6000); }
            }
            var section = document.getElementById('integrations');
            if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    } catch (e) {}
}
